export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  category: string;
  categorySlug: string;
  rating: number;
  views: string;
  description: string;
  status: '连载中' | '已完结';
  tags: string[];
  chapters: ComicChapter[];
  updateDate: string;
}

export const categories = [
  { name: '韩漫', slug: 'korean', icon: 'ri-earth-line' },
  { name: '日漫', slug: 'japanese', icon: 'ri-global-line' },
  { name: '国漫', slug: 'chinese', icon: 'ri-flag-line' },
  { name: '美漫', slug: 'american', icon: 'ri-planet-line' },
  { name: '耽美', slug: 'danmei', icon: 'ri-hearts-line' },
  { name: '热血', slug: 'action', icon: 'ri-fire-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
];

export const comics: Comic[] = [
  {
    id: 'jiajiao-laoshi',
    title: '家教老师',
    author: '朴志浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20webtoon%20cover%20style%20illustration%20of%20a%20handsome%20young%20male%20teacher%20in%20a%20classroom%20setting%2C%20clean%20modern%20art%20style%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20Korean%20digital%20illustration%20aesthetic%2C%20muted%20warm%20color%20palette%2C%20simple%20elegant%20background%2C%20vertical%20composition%2C%20high%20quality%20webtoon%20art&width=800&height=1067&seq=comic-cover-001&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    rating: 9.6,
    views: '1280万',
    description: '名校大学生李贤宇为了赚取生活费，成为了高中生姜秀雅的家教老师。原本只是普通的补习关系，却在朝夕相处中逐渐产生了微妙的情愫。面对社会舆论、师生伦理以及家庭的反对，两人能否冲破重重阻碍走到一起？一段甜蜜又虐心的禁忌之恋即将展开。',
    status: '连载中',
    tags: ['恋爱', '都市', '师生', '甜虐'],
    chapters: [
      { id: 'ch-120', title: '第120话 最终的决定', chapterNumber: 120, updateDate: '2026-07-07' },
      { id: 'ch-119', title: '第119话 无法说出口的话', chapterNumber: 119, updateDate: '2026-06-30' },
      { id: 'ch-118', title: '第118话 雨中的告白', chapterNumber: 118, updateDate: '2026-06-23' },
      { id: 'ch-117', title: '第117话 深夜的电话', chapterNumber: 117, updateDate: '2026-06-16' },
      { id: 'ch-116', title: '第116话 她的秘密', chapterNumber: 116, updateDate: '2026-06-09' },
    ],
    updateDate: '2026-07-07',
  },
  {
    id: 'boss-sweetheart',
    title: '社长的甜心宝贝',
    author: '金恩淑',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romance%20webtoon%20cover%20featuring%20a%20beautiful%20young%20woman%20and%20a%20handsome%20CEO%20in%20formal%20attire%2C%20office%20romance%20theme%2C%20elegant%20Korean%20digital%20art%20style%2C%20warm%20romantic%20lighting%2C%20soft%20pastel%20background%2C%20vertical%20webtoon%20composition%2C%20clean%20modern%20aesthetic&width=800&height=1067&seq=comic-cover-002&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    rating: 9.3,
    views: '965万',
    description: '平凡上班族林小染意外成为了冷酷社长沈墨言的私人秘书，原本以为只是一份工作，却没想到社长对她展开了热烈的追求。然而这段办公室恋情并非一帆风顺，竞争对手的暗算、家族企业的纠葛，都成为了两人感情路上的绊脚石。',
    status: '已完结',
    tags: ['恋爱', '职场', '总裁', '甜宠'],
    chapters: [
      { id: 'ch-95', title: '第95话 最终的幸福（大结局）', chapterNumber: 95, updateDate: '2026-05-20' },
      { id: 'ch-94', title: '第94话 求婚', chapterNumber: 94, updateDate: '2026-05-13' },
      { id: 'ch-93', title: '第93话 家人的认可', chapterNumber: 93, updateDate: '2026-05-06' },
      { id: 'ch-92', title: '第92话 真相大白', chapterNumber: 92, updateDate: '2026-04-29' },
      { id: 'ch-91', title: '第91话 危机来临', chapterNumber: 91, updateDate: '2026-04-22' },
    ],
    updateDate: '2026-05-20',
  },
  {
    id: 'demon-hunter',
    title: '猎魔人传说',
    author: '李承焕',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20featuring%20a%20mysterious%20warrior%20with%20a%20sword%20in%20a%20moody%20atmospheric%20scene%2C%20action%20packed%20composition%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20Korean%20digital%20illustration%20style%2C%20dark%20warm%20tones%2C%20vertical%20webtoon%20format%2C%20epic%20fantasy%20aesthetic&width=800&height=1067&seq=comic-cover-003&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    rating: 9.7,
    views: '2150万',
    description: '在妖魔横行的世界里，猎魔人韩辰背负着灭门之仇踏上了复仇之路。一路斩妖除魔，他逐渐发现幕后的真正黑手竟然是……一场跨越人魔两界的史诗级冒险即将展开，热血与感动交织的奇幻巨作！',
    status: '连载中',
    tags: ['热血', '奇幻', '战斗', '复仇'],
    chapters: [
      { id: 'ch-210', title: '第210话 最终决战序幕', chapterNumber: 210, updateDate: '2026-07-06' },
      { id: 'ch-209', title: '第209话 觉醒之力', chapterNumber: 209, updateDate: '2026-06-29' },
      { id: 'ch-208', title: '第208话 绝境求生', chapterNumber: 208, updateDate: '2026-06-22' },
      { id: 'ch-207', title: '第207话 同伴的抉择', chapterNumber: 207, updateDate: '2026-06-15' },
      { id: 'ch-206', title: '第206话 黑暗中的光芒', chapterNumber: 206, updateDate: '2026-06-08' },
    ],
    updateDate: '2026-07-06',
  },
  {
    id: 'campus-god',
    title: '校园之神',
    author: '赵敏赫',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20school%20life%20webtoon%20cover%20featuring%20a%20charismatic%20male%20student%20in%20school%20uniform%20standing%20in%20a%20campus%20setting%2C%20youth%20drama%20theme%2C%20bright%20warm%20daylight%2C%20Korean%20animation%20art%20style%2C%20clean%20minimal%20background%2C%20vertical%20composition%2C%20modern%20school%20aesthetic&width=800&height=1067&seq=comic-cover-004&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    rating: 8.9,
    views: '560万',
    description: '转学生林峰来到圣澜高中，凭借惊人的运动天赋和过人的智慧，迅速成为校园风云人物。然而他的到来也打破了学校原有的势力平衡。面对校园霸凌、学业压力和青涩的初恋，林峰将如何书写属于他的校园传奇？',
    status: '连载中',
    tags: ['校园', '热血', '青春', '励志'],
    chapters: [
      { id: 'ch-78', title: '第78话 最后的对决', chapterNumber: 78, updateDate: '2026-07-05' },
      { id: 'ch-77', title: '第77话 友情的考验', chapterNumber: 77, updateDate: '2026-06-28' },
      { id: 'ch-76', title: '第76话 暴风雨前夕', chapterNumber: 76, updateDate: '2026-06-21' },
    ],
    updateDate: '2026-07-05',
  },
  {
    id: 'love-signal',
    title: '心动信号',
    author: '尹彩媛',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20webtoon%20cover%20showing%20a%20couple%20sharing%20earbuds%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20color%20palette%2C%20sweet%20romance%20vibe%2C%20Korean%20digital%20illustration%2C%20gentle%20spring%20lighting%2C%20vertical%20webtoon%20format%2C%20dreamy%20atmosphere&width=800&height=1067&seq=comic-cover-005&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    rating: 9.1,
    views: '780万',
    description: '少女白井优香拥有一项特殊能力——她能听到喜欢她的人的心跳声。某天，她发现学校里最受欢迎的四个男生同时对她心跳加速！这场甜蜜又混乱的多角恋，最终会走向怎样的结局？',
    status: '已完结',
    tags: ['恋爱', '校园', '异能', '多角恋'],
    chapters: [
      { id: 'ch-62', title: '第62话 最终的选择（大结局）', chapterNumber: 62, updateDate: '2026-04-15' },
      { id: 'ch-61', title: '第61话 最终心意', chapterNumber: 61, updateDate: '2026-04-08' },
      { id: 'ch-60', title: '第60话 四个人的告白', chapterNumber: 60, updateDate: '2026-04-01' },
    ],
    updateDate: '2026-04-15',
  },
  {
    id: 'secret-garden',
    title: '秘密花园',
    author: '朴智恩',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20cover%20showing%20a%20woman%20walking%20through%20a%20moonlit%20secret%20garden%20with%20glowing%20flowers%2C%20fantasy%20mystery%20theme%2C%20cool%20night%20tones%20with%20warm%20accents%2C%20Korean%20digital%20art%20style%2C%20atmospheric%20lighting%2C%20vertical%20webtoon%20composition%2C%20enchanting%20aesthetic&width=800&height=1067&seq=comic-cover-006&orientation=portrait',
    category: '韩漫',
    categorySlug: 'korean',
    rating: 9.4,
    views: '1560万',
    description: '珠宝设计师尹彩琳偶然搬进了一栋古老的庄园，在后院发现了荒废已久的秘密花园。每当月圆之夜，花园中就会出现一位神秘的男子。随着探索的深入，她发现这座花园连接着两个时空，而那位男子竟是百年前失踪的庄园主人……',
    status: '连载中',
    tags: ['悬疑', '奇幻', '爱情', '穿越'],
    chapters: [
      { id: 'ch-88', title: '第88话 时空的裂缝', chapterNumber: 88, updateDate: '2026-07-08' },
      { id: 'ch-87', title: '第87话 百年前的真相', chapterNumber: 87, updateDate: '2026-07-01' },
      { id: 'ch-86', title: '第86话 命运之夜', chapterNumber: 86, updateDate: '2026-06-24' },
      { id: 'ch-85', title: '第85话 照片中的身影', chapterNumber: 85, updateDate: '2026-06-17' },
      { id: 'ch-84', title: '第84话 另一边的世界', chapterNumber: 84, updateDate: '2026-06-10' },
    ],
    updateDate: '2026-07-08',
  },
  {
    id: 'blade-dancer',
    title: '刀锋舞者',
    author: '山田健太',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20cover%20featuring%20a%20female%20samurai%20dancer%20with%20a%20katana%20in%20dynamic%20motion%2C%20action%20packed%20composition%20with%20flowing%20fabric%2C%20dramatic%20Japanese%20ink%20wash%20aesthetic%2C%20warm%20earthy%20tones%2C%20vertical%20format%2C%20epic%20samurai%20theme&width=800&height=1067&seq=comic-cover-007&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    rating: 9.5,
    views: '1890万',
    description: '江户时代的京都，艺伎花魁千代子同时是一位隐世刀术高手。当幕府黑暗势力威胁到她在乎的人时，她不得不拔出封印已久的妖刀，以刀锋之舞守护心中的正义。华丽的战斗场面与深沉的日本美学交织的武侠传奇。',
    status: '连载中',
    tags: ['热血', '历史', '武侠', '战斗'],
    chapters: [
      { id: 'ch-145', title: '第145话 剑之极意', chapterNumber: 145, updateDate: '2026-07-04' },
      { id: 'ch-144', title: '第144话 幕府之影', chapterNumber: 144, updateDate: '2026-06-27' },
      { id: 'ch-143', title: '第143话 妖刀觉醒', chapterNumber: 143, updateDate: '2026-06-20' },
    ],
    updateDate: '2026-07-04',
  },
  {
    id: 'star-cafe',
    title: '星空咖啡馆',
    author: '陈小雨',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20cozy%20Chinese%20manhua%20cover%20showing%20a%20cute%20barista%20girl%20in%20a%20starry%20night%20cafe%20setting%2C%20slice%20of%20life%20theme%2C%20warm%20ambient%20lighting%2C%20Chinese%20digital%20illustration%20style%2C%20soft%20pastel%20colors%2C%20vertical%20composition%2C%20healing%20atmosphere&width=800&height=1067&seq=comic-cover-008&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    rating: 8.7,
    views: '430万',
    description: '在大城市打拼的年轻人苏小雨，辞去工作后在老街开了一家小小的咖啡馆。每个来到咖啡馆的客人都带着自己的故事，而苏小雨用一杯杯温暖的咖啡治愈着每一个疲惫的心灵。',
    status: '已完结',
    tags: ['治愈', '日常', '美食', '都市'],
    chapters: [
      { id: 'ch-50', title: '第50话 星辰与咖啡（大结局）', chapterNumber: 50, updateDate: '2026-03-10' },
      { id: 'ch-49', title: '第49话 再出发', chapterNumber: 49, updateDate: '2026-03-03' },
      { id: 'ch-48', title: '第48话 告别与相遇', chapterNumber: 48, updateDate: '2026-02-24' },
    ],
    updateDate: '2026-03-10',
  },
  {
    id: 'neon-blade',
    title: '霓虹刀锋',
    author: '马克·陈',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20cyberpunk%20themed%20comic%20cover%20featuring%20a%20futuristic%20warrior%20with%20neon%20glowing%20blade%20in%20a%20dystopian%20cityscape%2C%20sci-fi%20action%20theme%2C%20vibrant%20neon%20colors%20against%20dark%20background%2C%20modern%20digital%20illustration%2C%20vertical%20format%2C%20dynamic%20composition&width=800&height=1067&seq=comic-cover-009&orientation=portrait',
    category: '美漫',
    categorySlug: 'american',
    rating: 9.0,
    views: '670万',
    description: '2057年，新东京。赏金猎人凌在霓虹灯笼罩的地下世界执行任务。当一桩看似简单的案件牵扯出足以颠覆整个城市权力的惊天阴谋时，凌必须在正义与生存之间做出选择。',
    status: '连载中',
    tags: ['科幻', '赛博朋克', '动作', '悬疑'],
    chapters: [
      { id: 'ch-35', title: '第35话 霓虹之下', chapterNumber: 35, updateDate: '2026-07-03' },
      { id: 'ch-34', title: '第34话 追猎', chapterNumber: 34, updateDate: '2026-06-26' },
      { id: 'ch-33', title: '第33话 暗流涌动', chapterNumber: 33, updateDate: '2026-06-19' },
    ],
    updateDate: '2026-07-03',
  },
  {
    id: 'eternal-love',
    title: '永恒之爱',
    author: '韩素希',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20boys%20love%20genre%20cover%20featuring%20two%20elegant%20young%20men%20in%20a%20tender%20embrace%2C%20romantic%20BL%20theme%2C%20soft%20dreamy%20lighting%2C%20Korean%20digital%20art%20style%2C%20warm%20muted%20colors%2C%20vertical%20webtoon%20composition%2C%20emotional%20atmosphere&width=800&height=1067&seq=comic-cover-010&orientation=portrait',
    category: '耽美',
    categorySlug: 'danmei',
    rating: 9.2,
    views: '890万',
    description: '音乐学院的优等生金泰亨一直暗恋着同系的钢琴天才朴智旻。一次偶然的合作让两人越走越近，音乐成为了他们之间最美的语言。然而家庭的压力和社会的偏见，让这段感情充满了变数。',
    status: '连载中',
    tags: ['耽美', '音乐', '校园', '治愈'],
    chapters: [
      { id: 'ch-56', title: '第56话 为你弹奏', chapterNumber: 56, updateDate: '2026-07-02' },
      { id: 'ch-55', title: '第55话 月光下的合奏', chapterNumber: 55, updateDate: '2026-06-25' },
      { id: 'ch-54', title: '第54话 心动的音符', chapterNumber: 54, updateDate: '2026-06-18' },
    ],
    updateDate: '2026-07-02',
  },
  {
    id: 'death-note-re',
    title: '死亡笔记 RE',
    author: '渡边凉',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20psychological%20thriller%20manga%20cover%20featuring%20a%20mysterious%20notebook%20and%20shadowy%20figure%2C%20suspense%20theme%2C%20high%20contrast%20dramatic%20lighting%2C%20Japanese%20manga%20art%20style%2C%20dark%20atmospheric%20composition%2C%20vertical%20format%2C%20ominous%20vibe&width=800&height=1067&seq=comic-cover-011&orientation=portrait',
    category: '日漫',
    categorySlug: 'japanese',
    rating: 9.8,
    views: '3200万',
    description: '天才高中生夜神月意外捡到了一本死亡笔记，只要在上面写下人名，那个人就会死亡。他化名"基拉"，开始用自己的方式制裁罪犯。然而神秘侦探L的出现，让这场智力较量进入了白热化阶段。经典重制版，全新画风！',
    status: '连载中',
    tags: ['悬疑', '推理', '犯罪', '心理'],
    chapters: [
      { id: 'ch-45', title: '第45话 新的基拉', chapterNumber: 45, updateDate: '2026-07-07' },
      { id: 'ch-44', title: '第44话 L的推理', chapterNumber: 44, updateDate: '2026-06-30' },
      { id: 'ch-43', title: '第43话 致命游戏', chapterNumber: 43, updateDate: '2026-06-23' },
      { id: 'ch-42', title: '第42话 笔记的规则', chapterNumber: 42, updateDate: '2026-06-16' },
      { id: 'ch-41', title: '第41话 命运的相遇', chapterNumber: 41, updateDate: '2026-06-09' },
    ],
    updateDate: '2026-07-07',
  },
  {
    id: 'martial-legend',
    title: '武道传说',
    author: '林风',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20manhua%20cover%20showing%20a%20powerful%20warrior%20in%20traditional%20Chinese%20robes%20performing%20martial%20arts%20in%20a%20mountainous%20landscape%2C%20wuxia%20theme%2C%20ink%20brush%20aesthetic%2C%20Chinese%20digital%20illustration%2C%20warm%20earthy%20tones%2C%20vertical%20format%2C%20epic%20scale&width=800&height=1067&seq=comic-cover-012&orientation=portrait',
    category: '国漫',
    categorySlug: 'chinese',
    rating: 9.1,
    views: '1100万',
    description: '废柴少年叶凡偶然获得上古武道传承，从此踏上了逆天改命的修炼之路。从默默无闻到名震天下，他面对的不仅是更强大的敌人，还有内心对力量的渴望与恐惧。一部热血沸腾的东方玄幻传奇。',
    status: '连载中',
    tags: ['热血', '玄幻', '修炼', '东方'],
    chapters: [
      { id: 'ch-180', title: '第180话 武道巅峰', chapterNumber: 180, updateDate: '2026-07-06' },
      { id: 'ch-179', title: '第179话 血脉觉醒', chapterNumber: 179, updateDate: '2026-06-29' },
      { id: 'ch-178', title: '第178话 九死一生', chapterNumber: 178, updateDate: '2026-06-22' },
    ],
    updateDate: '2026-07-06',
  },
];

export const featuredComicIds = ['jiajiao-laoshi', 'demon-hunter', 'secret-garden', 'death-note-re'];
export const hotComicIds = ['jiajiao-laoshi', 'boss-sweetheart', 'demon-hunter', 'death-note-re', 'secret-garden', 'eternal-love'];
export const newComicIds = ['secret-garden', 'jiajiao-laoshi', 'death-note-re', 'demon-hunter', 'blade-dancer', 'martial-legend', 'campus-god', 'neon-blade'];
export const recommendedComicIds = ['love-signal', 'star-cafe', 'eternal-love', 'boss-sweetheart', 'blade-dancer', 'neon-blade'];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(id: string, limit: number = 4): Comic[] {
  const comic = getComicById(id);
  if (!comic) return [];
  return comics
    .filter((c) => c.id !== id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
}